import { SiteTypes } from '../../types';
import clientConfig from '../../clientConfig';

export function isPingIdentityEnabled(siteType: SiteTypes, enabled: boolean) {
  const hasPingIdentityAuth = clientConfig.pingIdentityAuth?.enabled;

  return !!hasPingIdentityAuth && siteType === SiteTypes.EVENT && enabled;
}
